// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Contractor } from '../models';
import { ContractorCreate } from '../models';
import { ContractorEdit } from '../models';
import { ContractorList } from '../models';
import { ContractorNew } from '../models';
import { ContractorNewEdit } from '../models';
import { ContractorNewList } from '../models';
import { ErrorResponse } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * ContractorApi - axios parameter creator
 * @export
 */
export const ContractorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new contractor.
         * @param {ContractorCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ContractorCreate, options: any = {}): RequestArgs {
            const localVarPath = `/v1/contractor`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new contractor.
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractorNew(body?: ContractorNewEdit, options: any = {}): RequestArgs {
            const localVarPath = `/v1/contractors2`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractorNew(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteContractorNew.');
            }
            const localVarPath = `/v1/contractor2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ContractorEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editContractorNew(id: string, body?: ContractorNewEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editContractorNew.');
            }
            const localVarPath = `/v1/contractor2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorNew(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getContractorNew.');
            }
            const localVarPath = `/v1/contractor2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {string} [userId] 
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(userId?: string, title?: string, shortTitle?: string, inn?: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/v1/contractors`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (shortTitle !== undefined) {
                localVarQueryParameter['shortTitle'] = shortTitle;
            }

            if (inn !== undefined) {
                localVarQueryParameter['inn'] = inn;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {'juridical' | 'physical'} [type] 
         * @param {string} [companyId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [responsibleIds] 
         * @param {string} [searchJuridical] title, shortTitle, inn
         * @param {string} [searchPhysical] fullName, username, phone, email
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {string} [snils] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [studentIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContractorNew(type?: 'juridical' | 'physical', companyId?: string, userIds?: Array<string>, responsibleIds?: Array<string>, searchJuridical?: string, searchPhysical?: string, title?: string, shortTitle?: string, inn?: string, snils?: string, email?: string, phone?: string, firstName?: string, lastName?: string, middleName?: string, studentIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/v1/contractors2`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (userIds) {
                localVarQueryParameter['userIds'] = userIds.join(COLLECTION_FORMATS.csv);
            }

            if (responsibleIds) {
                localVarQueryParameter['responsibleIds'] = responsibleIds.join(COLLECTION_FORMATS.csv);
            }

            if (searchJuridical !== undefined) {
                localVarQueryParameter['searchJuridical'] = searchJuridical;
            }

            if (searchPhysical !== undefined) {
                localVarQueryParameter['searchPhysical'] = searchPhysical;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (shortTitle !== undefined) {
                localVarQueryParameter['shortTitle'] = shortTitle;
            }

            if (inn !== undefined) {
                localVarQueryParameter['inn'] = inn;
            }

            if (snils !== undefined) {
                localVarQueryParameter['snils'] = snils;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }

            if (middleName !== undefined) {
                localVarQueryParameter['middleName'] = middleName;
            }

            if (studentIds) {
                localVarQueryParameter['studentIds'] = studentIds.join(COLLECTION_FORMATS.csv);
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorApi - functional programming interface
 * @export
 */
export const ContractorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create new contractor.
         * @param {ContractorCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ContractorCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new contractor.
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractorNew(body?: ContractorNewEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorNew> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).createContractorNew(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractorNew(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).deleteContractorNew(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ContractorEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editContractorNew(id: string, body?: ContractorNewEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorNew> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).editContractorNew(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contractor> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorNew(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorNew> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).getContractorNew(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {string} [userId] 
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(userId?: string, title?: string, shortTitle?: string, inn?: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorList> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).list(userId, title, shortTitle, inn, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {'juridical' | 'physical'} [type] 
         * @param {string} [companyId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [responsibleIds] 
         * @param {string} [searchJuridical] title, shortTitle, inn
         * @param {string} [searchPhysical] fullName, username, phone, email
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {string} [snils] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [studentIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContractorNew(type?: 'juridical' | 'physical', companyId?: string, userIds?: Array<string>, responsibleIds?: Array<string>, searchJuridical?: string, searchPhysical?: string, title?: string, shortTitle?: string, inn?: string, snils?: string, email?: string, phone?: string, firstName?: string, lastName?: string, middleName?: string, studentIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorNewList> {
            const localVarAxiosArgs = ContractorApiAxiosParamCreator(configuration).listContractorNew(type, companyId, userIds, responsibleIds, searchJuridical, searchPhysical, title, shortTitle, inn, snils, email, phone, firstName, lastName, middleName, studentIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContractorApi - factory interface
 * @export
 */
export const ContractorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return ContractorApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Create new contractor.
         * @param {ContractorCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ContractorCreate, options?: any) {
            return ContractorApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new contractor.
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractorNew(body?: ContractorNewEdit, options?: any) {
            return ContractorApiFp(configuration).createContractorNew(body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractorNew(id: string, options?: any) {
            return ContractorApiFp(configuration).deleteContractorNew(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ContractorEdit, options?: any) {
            return ContractorApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit contractor.
         * @param {string} id 
         * @param {ContractorNewEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editContractorNew(id: string, body?: ContractorNewEdit, options?: any) {
            return ContractorApiFp(configuration).editContractorNew(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return ContractorApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get contractor.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractorNew(id: string, options?: any) {
            return ContractorApiFp(configuration).getContractorNew(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {string} [userId] 
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(userId?: string, title?: string, shortTitle?: string, inn?: string, offset?: number, limit?: number, options?: any) {
            return ContractorApiFp(configuration).list(userId, title, shortTitle, inn, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get contractors by filter.
         * @param {'juridical' | 'physical'} [type] 
         * @param {string} [companyId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [responsibleIds] 
         * @param {string} [searchJuridical] title, shortTitle, inn
         * @param {string} [searchPhysical] fullName, username, phone, email
         * @param {string} [title] 
         * @param {string} [shortTitle] 
         * @param {string} [inn] 
         * @param {string} [snils] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [middleName] 
         * @param {Array<string>} [studentIds] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContractorNew(type?: 'juridical' | 'physical', companyId?: string, userIds?: Array<string>, responsibleIds?: Array<string>, searchJuridical?: string, searchPhysical?: string, title?: string, shortTitle?: string, inn?: string, snils?: string, email?: string, phone?: string, firstName?: string, lastName?: string, middleName?: string, studentIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return ContractorApiFp(configuration).listContractorNew(type, companyId, userIds, responsibleIds, searchJuridical, searchPhysical, title, shortTitle, inn, snils, email, phone, firstName, lastName, middleName, studentIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
    };
};

/**
 * ContractorApi - object-oriented interface
 * @export
 * @class ContractorApi
 * @extends {BaseAPI}
 */
export class ContractorApi extends BaseAPI {
    /**
     * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Delete contractor.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public _delete(id: string, options?: any) {
        return ContractorApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Create new contractor.
     * @param {ContractorCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public create(body?: ContractorCreate, options?: any) {
        return ContractorApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Create new contractor.
     * @param {ContractorNewEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public createContractorNew(body?: ContractorNewEdit, options?: any) {
        return ContractorApiFp(this.configuration).createContractorNew(body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Delete contractor.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public deleteContractorNew(id: string, options?: any) {
        return ContractorApiFp(this.configuration).deleteContractorNew(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `contractor.user`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"contractor.user\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit contractor.
     * @param {string} id 
     * @param {ContractorEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public edit(id: string, body?: ContractorEdit, options?: any) {
        return ContractorApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">contractor</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit contractor.
     * @param {string} id 
     * @param {ContractorNewEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public editContractorNew(id: string, body?: ContractorNewEdit, options?: any) {
        return ContractorApiFp(this.configuration).editContractorNew(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get contractor.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public get(id: string, options?: any) {
        return ContractorApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get contractor.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public getContractorNew(id: string, options?: any) {
        return ContractorApiFp(this.configuration).getContractorNew(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get contractors by filter.
     * @param {string} [userId] 
     * @param {string} [title] 
     * @param {string} [shortTitle] 
     * @param {string} [inn] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public list(userId?: string, title?: string, shortTitle?: string, inn?: string, offset?: number, limit?: number, options?: any) {
        return ContractorApiFp(this.configuration).list(userId, title, shortTitle, inn, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get contractors by filter.
     * @param {'juridical' | 'physical'} [type] 
     * @param {string} [companyId] 
     * @param {Array<string>} [userIds] 
     * @param {Array<string>} [responsibleIds] 
     * @param {string} [searchJuridical] title, shortTitle, inn
     * @param {string} [searchPhysical] fullName, username, phone, email
     * @param {string} [title] 
     * @param {string} [shortTitle] 
     * @param {string} [inn] 
     * @param {string} [snils] 
     * @param {string} [email] 
     * @param {string} [phone] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [middleName] 
     * @param {Array<string>} [studentIds] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public listContractorNew(type?: 'juridical' | 'physical', companyId?: string, userIds?: Array<string>, responsibleIds?: Array<string>, searchJuridical?: string, searchPhysical?: string, title?: string, shortTitle?: string, inn?: string, snils?: string, email?: string, phone?: string, firstName?: string, lastName?: string, middleName?: string, studentIds?: Array<string>, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'shortTitle' | 'inn' | 'email' | 'phone' | 'firstName' | 'middleName' | 'lastName' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return ContractorApiFp(this.configuration).listContractorNew(type, companyId, userIds, responsibleIds, searchJuridical, searchPhysical, title, shortTitle, inn, snils, email, phone, firstName, lastName, middleName, studentIds, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

}
